import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseApi } from '@web/app/store/api/createBaseApi'
import { VerifyDocumentResponse } from '../verify.types'

export const publicVerifyApi = createApi({
  reducerPath: 'publicVerifyApi',
  baseQuery: createBaseApi({
    baseUrl: import.meta.env.VITE_API_URL,
    timeout: 30000,
    authTokenPath: 'token',
    apiName: 'PUBLIC-VERIFY',
    debug: true,
    demoUrl: '',
  }),
  endpoints: (builder) => ({
    /**
     * 1. POST: Verificación mediante carga de archivo PDF físico.
     * Envía el FormData y espera la estructura completa del documento.
     */
    verifyDocument: builder.mutation<VerifyDocumentResponse, FormData>({
      query: (formData) => ({
        url: '/api/v1/public/documents/verify',
        method: 'POST',
        body: formData,
        extraOptions: {
          unauthenticated: true,
        },
      }),
      // LOG PARA EL POST
      transformResponse: (response: VerifyDocumentResponse) => {
        console.log('🚀 [POST] Verify Document Response:', response)
        return response
      },
    }),

    /**
     * 2. GET: Verificación mediante código UUID (o ID limpio).
     * Consulta el estado y detalle de un documento específico.
     */
    verifyDocumentByCode: builder.query<VerifyDocumentResponse, string>({
      query: (code) => ({
        url: `/api/v1/public/documents/verify/${code}`,
        method: 'GET',
        extraOptions: {
          unauthenticated: true,
        },
      }),
      // LOG PARA EL GET
      transformResponse: (response: VerifyDocumentResponse) => {
        console.log('🔍 [GET] Verify By Code Response:', response)
        return response
      },
    }),
  }),
})

export const {
  useVerifyDocumentMutation,
  useVerifyDocumentByCodeQuery,
  useLazyVerifyDocumentByCodeQuery,
} = publicVerifyApi
